module.exports = __webpack_public_path__ + "static/media/i-am-an-agent.106f7d5d.svg";